class TeeTimeBookingModel {
  constructor(teeTime, numOfPlayers) {
    this.teeTime = teeTime;
    this.numOfPlayers = numOfPlayers;
  }
}

export { TeeTimeBookingModel };
